/**
 * **Is this compendium action a tech attack?** Lancer-data and the v3 NPC pack mark one with
 * `attack: "tech"` on the action itself (Markerlight, Tear Down), but four v3 NPC features nest the
 * flag inside the effect they apply on a hit instead (`npc-gaps` 2.14): Blind, Chain and Pain
 * Transference carry it on an `add_special` entry, Drain Systems on an `add_status` entry. Both
 * shapes name the same thing, a tech attack whose success applies that effect, so the spawn freeze
 * (`techAttackActions`) and the action registry's `"attack"` route read either.
 */
const NESTED_EFFECT_FIELDS = ["add_special", "add_status"] as const;

export function isTechAttackAction(action: unknown): boolean {
  if (typeof action !== "object" || action === null) return false;
  const a = action as Record<string, unknown>;
  if (a["attack"] === "tech") return true;
  return NESTED_EFFECT_FIELDS.some((field) => {
    const entries = a[field];
    return Array.isArray(entries) && entries.some((e) => typeof e === "object" && e !== null && (e as { attack?: unknown }).attack === "tech");
  });
}
